module.exports = __webpack_public_path__ + "static/media/r22.54e94cbc.png";